import http from "@/http";

function getDownloadFileName(response) {
  const contentDisposition = response.headers["content-disposition"];
  const contentDispositionParts = contentDisposition.split(";");
  const filenamePart = contentDispositionParts.find((part) =>
    part.includes("filename=")
  );
  const filename = filenamePart.split("=")[1].replace(/"/g, "");
  return filename;
}

export default async function downloadFile(fileType, uuid) {
  const decodedUrl = decodeURIComponent(`/${fileType}/${uuid}`);
  const response = await http.get(decodedUrl, { responseType: "blob" });
  const blobURL = window.URL.createObjectURL(response.data);
  const tempLink = document.createElement("a");
  tempLink.style.display = "none";
  tempLink.href = blobURL;
  tempLink.setAttribute("download", getDownloadFileName(response));
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  setTimeout(() => {
    window.URL.revokeObjectURL(blobURL);
  }, 100);
}
